export default __webpack_public_path__ + "static/media/fig-22-fault-alternative-filled.dbf0722d.png";